<template lang="html">

  <div class="banner">

        <transition name="fade" mode='out-in'>
          <div v-if="showBanner===4" key="4" class="fogadj-orokbe" @click="$router.push('/orokbefogadas')">
              <h1 class="headline banner-title">Fogadj örökbe!</h1>
          </div>

          <div v-if="showBanner===2" key="2" class="tamogass" @click="$router.push('/helpus')">
            <h1 class="headline banner-title">Támogass minket!</h1>
          </div>

          <div v-if="showBanner===3" key="3" class="idigazdi" @click="$router.push('/orokbefogadas')">
            <h1 class="headline banner-title">Legyél ideiglenes gazdi!</h1>
          </div>

          <div v-if="showBanner===1" key="1"  @click="$router.push('/hirek')">
            <h1 class="headline banner-title">Látogass ki eseményeinkre!</h1>
          </div>
        </transition>
  </div>

</template>

<script>
let bannerflash;

export default {
  data(){
    return{
      showBanner: 1,
    }
  },
  mounted(){
    bannerflash = setInterval(()=>{
      this.showBanner === 4 ? this.showBanner=1 : this.showBanner+=1
    },5000);
  },
  destroyed(){
    clearInterval(bannerflash);
  }
}
</script>

<style lang="scss" scoped>

.banner{
  margin: auto;
  text-align: center;
  width: 90%;
  max-width: 500px;
  height: 100px;

  &>div{
    padding-top: 40px;
  }
  .banner-title{
    color: $almostblack;
    font-size: 1.6rem;
    display: block;
    &:hover{
      color: $silver;
      cursor: pointer;
      transform: scale(1.05);
    }

    @media(min-width:1200px){
      font-size: 2rem;
    }
  }
}

</style>
